import React from 'react'
import ContentSection from '../components/ContentSection/ContentSectionV1'

export default function ContentSectionV1(props) {
  // const {
  //   // businessData,
  //   // configData,
  //   // options,
  //   // gonationID,
  //   // variantName,
  //   // locationIndex,
  //   // isMultiLocationSite,
  // } = props

  return <ContentSection {...props} />
}
